export const SOCKET_EVENTS = {
  ANNOUNCEMENT: {
    CREATE_GROUP: "announcement:createGroup",
    MAKE_ANNOUNCEMENT: "announcement:make",
    READ_ANNOUNCEMENT: "announcement:read",
    NEW_ANNOUNCEMENT: "announcement:new",
  },
  CONNECTION: {
    CONNECT: "connect",
    DISCONNECT: "disconnect",
  },
  NOTIFICATION: {
    NEW: "notification",
  },
  MESSAGE: {
    NEW: "message",
    SEEN: "message:seen",
  },
  CHAT: {
    JOIN: "join",
    SEND_MESSAGE: "sendMessage",
    MESSAGE_READ: "messageRead",
    MESSAGE_SEEN: "messageSeen",
  },
};
